<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>{{ $t("navbar.connection") }}</h3>
      </div>

      <div class="main">
        <!-- 组委会 -->
        <div class="content">
          <p>{{ $t("connection.committee") }}</p>
          <div class="detail">
            <div class="row">
              <div class="left">
                <span class="name">{{ $t("card.unitName") }}：</span>
                <span>{{ $t("connection.name") }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("exhiInformat.address") }}</span>
                <span>{{ $t("connection.address") }}</span>
              </div>
            </div>
            <div class="row">
              <div class="left">
                <span class="name">{{ $t("exhiInformat.email") }}：</span>
                <span>chinaminexpo@vip.163.com</span>
              </div>
            </div>
            <div class="instance">
              <div class="distribution">
                <!-- <p class="title">
                  <span>{{$t('connection.principal')}}</span>
                </p> -->

                <div class="tab">
                  <table>
                    <tbody>
                      <tr class="thead">
                        <th
                          class="standard"
                          style="width: 137px;padding-left:15px"
                        >
                          {{ $t("special.serviceProject") }}
                        </th>
                        <th
                          class="standard"
                          style="width: 137px;padding-left:35px"
                        >
                          {{ $t("connection.serverContent") }}
                        </th>
                        <th style="width: 200px;" class="padding90">
                          {{ $t("special.linkman") }}
                        </th>
                        <th
                          class="notice"
                          style="width: 200px;padding-left:15px"
                        >
                          {{ $t("special.iphone") }}
                        </th>
                        <th class="notice" style="width:50%;padding-left:15px">
                          {{ $t("special.telephone") }}
                        </th>
                      </tr>
                      <tr class="th bg">
                        <th
                          colspan="5"
                          class="standard"
                          style="padding-left: 25vw"
                        >
                          {{ $t("connection.title") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th style="width: 137px;padding-left:15px">
                          {{ $t("connection.th2") }}
                        </th>
                        <th rowspan="3" style="width: 137px;padding-left:15px">
                          {{ $t("connection.th2serverContent") }}
                        </th>
                        <th class="padding90" style="width: 200px;">
                          {{ $t("connection.th2name") }}
                        </th>
                        <th>{{ $t("connection.th2iphone") }}</th>
                        <th>{{ $t("connection.thTelep") }}</th>
                      </tr>
                      <tr class="th">
                        <th>{{ $t("connection.th3") }}</th>
                        <th class="padding90">
                          {{ $t("connection.th3name") }}
                        </th>
                        <th>{{ $t("connection.th3iphone") }}</th>
                        <th>{{ $t("connection.th3Telep") }}</th>
                      </tr>
                      <tr class="th">
                        <th rowspan="1">{{ $t("connection.th4") }}</th>
                        <th class="padding90">
                          <span>
                            <span>{{ $t("connection.th4name") }}</span
                            ><br />
                            <span>{{ $t("connection.th5name") }}</span>
                          </span>
                        </th>
                        <th>
                          <span>
                            <span>{{ $t("connection.th4iphone") }}</span
                            ><br />
                            <span>{{ $t("connection.th5iphone") }}</span>
                          </span>
                        </th>
                        <th>
                          <span>
                            <span>{{ $t("connection.th4Telep") }}</span
                            ><br />
                            <span>{{ $t("connection.th5Telep") }}</span>
                          </span>
                        </th>
                      </tr>
                      <tr class="th bg">
                        <th
                          colspan="5"
                          class="standard"
                          style="padding-left: 25vw"
                        >
                          {{ $t("connection.title2") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th>{{ $t("connection.th6") }}</th>
                        <th>
                          {{ $t("connection.th6serverContent") }}
                        </th>
                        <th class="padding90">
                          {{ $t("connection.th6name") }}
                        </th>
                        <th>
                          {{ $t("connection.th6iphone") }}
                        </th>
                        <th>
                          {{ $t("connection.th6Telep") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th>{{ $t("connection.th7") }}</th>
                        <th>
                          {{ $t("connection.th7serverContent") }}
                        </th>
                        <th class="padding90">
                          {{ $t("connection.th7name") }}
                        </th>
                        <th>
                          {{ $t("connection.th7iphone") }}
                        </th>
                        <th>
                          {{ $t("connection.th7Telep") }}
                        </th>
                      </tr>
                      <tr class="th bg">
                        <th
                          colspan="5"
                          class="standard"
                          style="padding-left: 25vw"
                        >
                          {{ $t("connection.title3") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th>{{ $t("connection.th8") }}</th>
                        <th>
                          {{ $t("connection.th8serverContent") }}
                        </th>
                        <th class="padding90">
                          {{ $t("connection.th8name") }}
                        </th>
                        <th>
                          {{ $t("connection.th8iphone") }}
                        </th>
                        <th>
                          {{ $t("connection.th8Telep") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th>{{ $t("connection.th9") }}</th>
                        <th>
                          {{ $t("connection.th9serverContent") }}
                        </th>
                        <th class="padding90">
                          {{ $t("connection.th9name") }}
                        </th>
                        <th>
                          <span>
                            <span>{{ $t("connection.th9iphone1") }}</span
                            ><br />
                            <span>{{ $t("connection.th9iphone2") }}</span>
                          </span>
                        </th>
                        <th>
                          <span>
                            <span>{{ $t("connection.th9Telep1") }}</span
                            ><br />
                            <span> {{ $t("connection.th9Telep2") }}</span>
                          </span>
                        </th>
                      </tr>
                      <tr class="th">
                        <th>{{ $t("connection.th10") }}</th>
                        <th>
                          {{ $t("connection.th10serverContent") }}
                        </th>
                        <th class="padding90">
                          {{ $t("connection.th10name") }}
                        </th>
                        <th>
                          {{ $t("connection.th10iphone") }}
                        </th>
                        <th>
                          {{ $t("connection.th10Telep") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th>
                          {{ $t("connection.th11") }}
                        </th>
                        <th>
                          {{ $t("connection.th11serverContent") }}
                        </th>
                        <th rowspan="3" class="padding90">
                          <span> {{ $t("connection.th11name1") }} </span><br />
                          <span> {{ $t("connection.th11name2") }}</span
                          ><br />
                          <span> {{ $t("connection.th11name3") }}</span
                          ><br />
                        </th>
                        <th rowspan="3">
                          <span>
                            <span>{{ $t("connection.th11iphone1") }}</span
                            ><br />
                            <span>{{ $t("connection.th11iphone2") }}</span>
                          </span>
                        </th>
                        <th rowspan="3">
                          <span>
                            <span>{{ $t("connection.th11Telep1") }}</span
                            ><br />
                            <span>{{ $t("connection.th11Telep1") }}</span>
                          </span>
                        </th>
                      </tr>
                      <tr class="th">
                        <th>
                          {{ $t("connection.th12") }}
                        </th>
                        <th>
                          {{ $t("connection.th12serverContent") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th>
                          {{ $t("connection.th13") }}
                        </th>
                        <th>
                          {{ $t("connection.th13serverContent") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th>{{ $t("connection.th14") }}</th>
                        <th>
                          {{ $t("connection.th14serverContent") }}
                        </th>
                        <th class="padding90">
                          {{ $t("connection.th14name") }}
                        </th>
                        <th>
                          {{ $t("connection.th14iphone") }}
                        </th>
                        <th>
                          {{ $t("connection.th14Telep") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th>{{ $t("connection.th15") }}</th>
                        <th>
                          {{ $t("connection.th15serverContent") }}
                        </th>
                        <th class="padding90">
                          {{ $t("connection.th15name") }}
                        </th>
                        <th>
                          {{ $t("connection.th15iphone") }}
                        </th>
                        <th>
                          {{ $t("connection.th15Telep") }}
                        </th>
                      </tr>
                      <tr class="th bg">
                        <th
                          colspan="5"
                          class="standard"
                          style="padding-left: 25vw"
                        >
                          {{ $t("connection.title4") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th rowspan="2">{{ $t("connection.th16") }}</th>
                        <th rowspan="2">
                          {{ $t("connection.th16serverContent") }}
                        </th>
                        <th class="padding90">
                          {{ $t("connection.th16name") }}
                        </th>
                        <th>
                          {{ $t("connection.th16iphone") }}
                        </th>
                        <th>
                          {{ $t("connection.th16Telep") }}
                        </th>
                      </tr>
                      <tr class="th">
                        <th class="padding90">
                          {{ $t("connection.th17name") }}
                        </th>
                        <th>
                          {{ $t("connection.th17iphone") }}
                        </th>
                        <th>
                          {{ $t("connection.th17Telep") }}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
            </div>
          </div>
        </div>

        <!--展览联系人-->
        <div class="content">
          <p>{{ $t("connection.haiwai.overseasName") }}</p>
          <div class="detail">
            <div class="row">
              <div class="left">
                <span class="name">{{ $t("card.unitName") }}：</span>
                <span>{{ $t("connection.haiwai.companyName") }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name"
                  >{{ $t("connection.haiwai.hongkAddree") }}：</span
                >
                <span>{{ $t("connection.haiwai.address") }}</span>
              </div>
              <div class="right">
                <span class="name"
                  >{{ $t("connection.haiwai.telePerson") }}：</span
                >
                <span>{{ $t("connection.haiwai.connPerson") }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name"
                  >{{ $t("connection.haiwai.beijingAddress") }}：</span
                >
                <span>{{ $t("connection.haiwai.bjAddress") }}</span>
              </div>
              <div class="right">
                <span class="name"
                  >{{ $t("connection.haiwai.telePerson") }}：</span
                >
                <span>{{ $t("connection.haiwai.connPerson2") }}</span>
              </div>
            </div>
          </div>
        </div>

        <!--主场联系人-->
        <div class="content">
          <p>{{ $t("connection.zhuchang.homeName") }}</p>
          <div class="detail">
            <div class="row">
              <div class="left">
                <span class="name">{{ $t("card.unitName") }}：</span>
                <span>{{ $t("connection.zhuchang.compayName") }}</span>
              </div>
              <div class="right">
                <span class="name"
                  >{{ $t("connection.zhuchang.address") }}：</span
                >
                <span>{{ $t("connection.zhuchang.Address") }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name"
                  >{{ $t("connection.zhuchang.iphone") }}：</span
                >
                <span>{{ $t("connection.zhuchang.iphoneNum") }}</span>
              </div>
            </div>
            <!-- 表格 -->
            <div class="instance">
              <div class="distribution">
                <div class="tab">
                  <table>
                    <tbody>
                      <!-- 第一行 -->
                      <tr class="thead">
                        <th
                          class="standard"
                          style="width: 15%;padding-left:15px"
                        >
                          {{ $t("homepage.pavilion") }}
                        </th>
                        <th style="width: 200px;padding-left:15px">
                          {{ $t("special.linkman") }}
                        </th>
                        <th
                          class="notice"
                          style="width: 200px;padding-left:15px"
                        >
                          {{ $t("connection.zhuchang.extensionNum") }}
                        </th>
                        <th
                          class="notice"
                          style="width: 200px;padding-left:15px"
                        >
                          {{ $t("connection.zhuchang.telementNum") }}
                        </th>
                        <th
                          class="notice"
                          style="width: 200px;padding-left:15px"
                        >
                          {{ $t("connection.zhuchang.email") }}
                        </th>
                      </tr>
                      <!-- 第二行 -->
                      <tr class="th">
                        <th>{{ $t("connection.zhuchang.th2") }}</th>
                        <th>{{ $t("connection.zhuchang.th2Name") }}</th>
                        <th>{{ $t("connection.zhuchang.th2exten") }}</th>
                        <th>{{ $t("connection.zhuchang.th2iphone") }}</th>
                        <th>wangsisi_mht@126.com</th>
                      </tr>
                      <!-- 三行 -->
                      <tr class="th">
                        <th>{{ $t("connection.zhuchang.th4") }}</th>
                        <th>{{ $t("connection.zhuchang.th4Name") }}</th>
                        <th>{{ $t("connection.zhuchang.th4exten") }}</th>
                        <th>{{ $t("connection.zhuchang.th4iphone") }}</th>
                        <th>zhuboyan_mht@126.com</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--展览会负责人-->
        <div class="content">
          <p>{{ $t("connection.diaozhuang.dzName") }}</p>
          <div class="detail">
            <div class="row">
              <div class="left">
                <span class="name"
                  >{{ $t("connection.zhuchang.address") }}：</span
                >
                <span>{{ $t("connection.diaozhuang.companyAddress") }}</span>
              </div>
            </div>
            <div class="row">
              <div class="left">
                <span class="name"
                  >{{ $t("connection.diaozhuang.projectManager") }}：</span
                >
              </div>
            </div>
            <div class="row">
              <div class="left">
                <span class="name">{{ $t("special.linkman") }}：</span>
                <span>{{ $t("connection.diaozhuang.manager") }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("card.email") }}：</span>
                <span>{{ $t("diaozhuang.email") }}</span>
              </div>
            </div>
            <div class="row">
              <div class="left">
                <span class="name">{{ $t("special.telephone") }}：</span>
                <span>{{ $t("connection.diaozhuang.telep") }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("special.iphone") }}：</span>
                <span>{{ $t("connection.diaozhuang.phone") }}</span>
              </div>
            </div>
            <div class="row">
              <div class="left">
                <span class="name"
                  >{{ $t("connection.diaozhuang.principalTele") }}：</span
                >
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div class="instance">
            <div class="distribution">
              <div class="tab">
                <table>
                  <tbody>
                    <!-- 第一行 -->
                    <tr class="thead">
                      <th class="standard" style="width: 15%;padding-left:15px">
                        {{ $t("homepage.pavilion") }}
                      </th>
                      <th style="width: 200px;padding-left:15px">
                        {{ $t("card.name") }}
                      </th>
                      <th class="notice" style="width: 200px;padding-left:15px">
                        {{ $t("special.iphone") }}
                      </th>
                      <th class="notice" style="width: 200px;padding-left:15px">
                        {{ $t("connection.zhuchang.telementNum") }}
                      </th>
                      <th class="notice" style="width: 200px;padding-left:15px">
                        {{ $t("card.email") }}
                      </th>
                    </tr>
                    <!-- 第二行 -->
                    <tr class="th">
                      <th>{{ $t("connection.diaozhuang.th") }}</th>
                      <th>{{ $t("connection.diaozhuang.thName") }}</th>
                      <th>{{ $t("connection.diaozhuang.thIphone") }}</th>
                      <th>lihailong@ciec.com.cn</th>
                    </tr>

                    <!-- 四行 -->
                    <tr class="th">
                      <th>{{ $t("connection.diaozhuang.th2") }}</th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th2Name") }}
                      </th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th2Iphone") }}
                      </th>
                      <th class="th">zhangyi@ciec.com.cn</th>
                    </tr>

                    <!-- 四行 -->
                    <tr class="th">
                      <th>{{ $t("connection.diaozhuang.th3") }}</th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th3Name") }}
                      </th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th3Iphone") }}
                      </th>
                      <th class="th">fangjianliang@ciec.com.cn</th>
                    </tr>

                    <!-- 五行 -->
                    <tr class="th">
                      <th>{{ $t("connection.diaozhuang.th4") }}</th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th4Name") }}
                      </th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th4Iphone") }}
                      </th>
                      <th class="th">caolixin@ciec.com.cn</th>
                    </tr>

                    <!-- 六行 -->
                    <tr class="th">
                      <th>{{ $t("connection.diaozhuang.th5") }}</th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th5Name") }}
                      </th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th5Iphone") }}
                      </th>
                      <th class="th">gongyanzhi@ciec.com.cn</th>
                    </tr>

                    <!-- 七行 -->
                    <tr class="th">
                      <th>{{ $t("connection.diaozhuang.th6") }}</th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th6Name") }}
                      </th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th6Iphone") }}
                      </th>
                      <th class="th">zhouqiang@ciec.com.cn</th>
                    </tr>

                    <!-- 七行 -->
                    <tr class="th">
                      <th>{{ $t("connection.diaozhuang.th7") }}</th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th7Name") }}
                      </th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th7Iphone") }}
                      </th>
                      <th class="th">liangzidong@ciec.com.cn</th>
                    </tr>

                    <!-- 七行 -->
                    <tr class="th">
                      <th>{{ $t("connection.diaozhuang.th8") }}</th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th8Name") }}
                      </th>
                      <th class="th">
                        {{ $t("connection.diaozhuang.th8Iphone") }}
                      </th>
                      <th class="th">cuiliwei@ciec.com.cn</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!--国内招展代理-->
        <div class="content">
          <p>{{ $t("connection.hotel.hotelTitle") }}</p>
          <div class="detail">
            <div class="row">
              <div class="left">
                <span class="name">{{ $t("card.unitName") }}：</span>
                <span>{{ $t("connection.hotel.companyName") }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("special.linkman") }}：</span>
                <span>{{ $t("connection.hotel.connectPer") }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">{{ $t("card.email") }}：</span>
                <span>times@sdlm.cn</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("special.telephone") }}：</span>
                <span>{{ $t("connection.hotel.telep") }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <img src="../../assets/hotel_QRCode.png" alt="识别二维码可订酒店"><br>
                <span>{{ $t("connection.hotel.emailTip") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Connection",
};
</script>

<style lang="scss" scoped>
.padding90 {
  padding-left: 90px !important;
}
.bg {
  background: #f6f6f7;
}
.body {
  //margin: 20px 30px 20px 30px;
  font-family: PingFangSC-Regular, PingFang SC;

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #e8e8e8;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 40px 30px 0;

    .content {
      margin-bottom: 40px;
      p {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 800;
        color: #333333;
        padding-bottom: 9px;
        border-bottom: 1px solid #e9e9e9;
      }

      .detail {
        margin: 30px 0px 0;

        .row {
          display: flex;
          padding-bottom: 30px;
          font-weight: 400;
          color: #333333;
          font-size: 16px;
          justify-content: space-between;

          .name {
            font-size: 14px;
            text-align: right;
            white-space: nowrap;
          }

          .left {
            width: 550px;
            display: flex;
            align-items: center;
          }
          .right {
            display: flex;
            flex-grow: 1;
            align-items: center;
            .special {
              display: block;
            }
            .right-content {
              width: 318px;
              display: flex;
              flex-wrap: wrap;
              margin-top: 40px;
              span {
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
}

.instance {
  margin-bottom: 20px;

  .distribution {
    .title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      padding-bottom: 9px;
      border-bottom: 1px solid #e9e9e9;
    }
    .tab {
      margin-top: 9px;
      table {
        border-collapse: collapse;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        border-radius: 3px 3px 0px 0px;
        height: 36px;
        width: 100%;
        tbody {
          // border: 1px solid #e8e8e8;
          .thead {
            height: 36px;
            background: #006fb8;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.85);
            line-height: 19px;
            text-align: left;
            padding-left: 20px;
          }
          .th {
            height: 62px;
            border-bottom: 1px solid #e8e8e8;
            line-height: 62px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            th {
              text-align: left;
              padding-left: 15px;
            }
          }
          //   tr:nth-child(even) {
          //     background: #f1f1f1;
          // }
        }
      }
    }
  }
}
</style>

<style scoped>
>>> .el-card__body {
  padding: 20px 0;
}
</style>
